// extracted by mini-css-extract-plugin
module.exports =  {"aside":"_1c9529d521--aside--ojSy4","sticky":"_1c9529d521--sticky--Bbsk7","sticky-top-space":"_1c9529d521--sticky-top-space--NpMy2"};